import { render } from "./ico-arrow-down.vue?vue&type=template&id=53e2d330&scoped=true"
const script = {}

import "./ico-arrow-down.vue?vue&type=style&index=0&id=53e2d330&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e2d330"]])

export default __exports__